export function formatWeight(weight: string | number): string {
  return (Number(weight) || 0).toLocaleString('en-US', {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  })
}
